import {
  AppliedFilterSection_Value,
  BrandFilterSection,
  FilterSection,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {useSelectedGroups} from '@aboutyou/ui-components';
import {
  useBrandSection,
  useNormalizedBrandGroups,
} from '../../shared/useBrandFilterSection';

type FilterBrandSection = {
  type: {
    $case: 'brand';
    brand: BrandFilterSection;
  };
};

export const useSelectedFavouriteBrands = ({
  filters,
  activeFilters,
}: {
  filters: FilterSection[];
  activeFilters: Map<string, string[] | undefined>;
}): AppliedFilterSection_Value[] => {
  const brandFilterSection = filters.find(
    filter => filter.type?.$case === 'brand',
  ) as FilterBrandSection | undefined;

  const brandData = brandFilterSection?.type.brand;
  const normalizedBrandGroups = useNormalizedBrandGroups(
    brandData ? brandData.brandGroups : [],
    false, // inline filters are used on desktop and as such we dont need highlighted brands logic, only used on mobile
  );

  const {activeSlugFilters} = useBrandSection({
    data: brandData ?? {slug: '', label: '', brandGroups: []},
    activeFilters,
  });

  const appliedPersonalizedBrands = useSelectedGroups({
    itemGroups: normalizedBrandGroups,
    search: '',
    activeIds: activeSlugFilters,
  });

  if (!appliedPersonalizedBrands) {
    return [];
  }

  return appliedPersonalizedBrands.items.map(brand => ({
    slug: brandData?.slug,
    value: {
      $case: 'attribute',
      attribute: {id: Number(brand.id), label: brand.label},
    },
  })) as AppliedFilterSection_Value[];
};
